import {
  Avatar,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorMode,
  useColorModeValue
} from "@chakra-ui/react";
import { Bell, CircleHelp, Moon, Search, Settings, Sun } from "lucide-react";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

export default function HeaderLinks(props) {
  const { variant, children, fixed, secondary, onOpen, ...rest } = props;

  let mainTeal = useColorModeValue("gray.300", "gray.300");
  let inputBg = useColorModeValue("white", "gray.800");
  let mainText = useColorModeValue("gray.700", "gray.200");
  let navbarIcon = useColorModeValue("gray.500", "gray.200");
  let searchIcon = useColorModeValue("gray.700", "gray.200");
  const [loggedInUsername, setLoggedInUsername] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const { colorMode, toggleColorMode } = useColorMode();

  const handleLogout = () => {
    localStorage.removeItem('username');
    setLoggedInUsername('');
    localStorage.removeItem('access_token')
    history.push("/login");
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };


  useEffect(() => {
    const username = localStorage.getItem('username');
    if (username) {
      setLoggedInUsername(username);
    }
  }, []);

  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }
  const settingsRef = React.useRef();
  return (
    <Flex
      pe={{ sm: "0px", md: "26px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
    >
      <Flex
        flexDirection={'row'}
        alignItems={'center'}
        gap={8}
        paddingX={18}
      >
        <Button 
          variant="ghost" 
          paddingX={0}
          color={'white'}
          _hover={{color: 'brand.800'}}
        >
          <Search size={35}/>
        </Button>
        <Button 
          variant="ghost" 
          paddingX={0}
          color={'white'}
          _hover={{color: 'brand.800'}}
        >
          <CircleHelp size={35}/>
        </Button>
        <Button 
          variant="ghost" 
          paddingX={0}
          color={'white'}
          _hover={{color: 'brand.800'}}
        >
          <Settings size={35}/>
        </Button>
        <Button 
          variant="ghost" 
          paddingX={0}
          color={'white'}
          _hover={{color: 'brand.800'}}
        >
          <Bell size={35}/>
        </Button>
      </Flex>
      <Menu>
        <Flex
          width="100px"
          alignItems="center"
          justifyContent="space-between"
          flexDirection="row"
        >
          <Button onClick={toggleColorMode} variant="ghost" paddingX={0}>
            { colorMode === "light" 
                ? <Moon size={35}/>
                : <Sun size={35}/>
            } 
          </Button>

          <MenuButton style={{width: "30px"}} onClick={toggleMenu}>

            {loggedInUsername ? (
              // <Avatar size="sm" src={`URL_DO_AVATAR/${loggedInUsername}.png`}>
              <>
                <Avatar srt="">
                  {/* {loggedInUsername} */}
                </Avatar>
              </>
            ) : (
              <Text as="button" color={mainText} fontWeight="bold">
                Voce esta deslogado
              </Text>
            )}
          </MenuButton>
          {isOpen && (
            <MenuList>
              {loggedInUsername && (
                <>
                  <p> &nbsp; Usuario: {loggedInUsername}</p>
                  <MenuItem onClick={handleLogout}>
                    <p>Sair</p>
                  </MenuItem>
                </>
              )}
            </MenuList>
          )}
        </Flex>
      </Menu>

    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};